import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 -960 960 960"

const CloseIcon = createSvgIcon(
  <>
    <path d='m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z' />
  </>,
  'CloseIcon'
)

export default CloseIcon
